import React from "react";

import { getUnitOptions } from "./Helper";
import SpecManagerInput from "./SpecManagerInput";
import "./SpecsQuantitative.css";
import SpecManagerSelect from "./SpecManagerSelect";

export default class SpecsQuantitative extends React.Component {
  onRangeOptionClick = (optionSelected) => {
    const { data, handleDataChange } = this.props;
    handleDataChange([optionSelected, data[1], data[2]]);
  }

  onUnitOptionClick = (optionSelected) => {
    const { data, handleDataChange } = this.props;
    handleDataChange([data[0], data[1], optionSelected]);
  }

  onInputChange = (value) => {
    const { data, handleDataChange } = this.props;
    handleDataChange([data[0], value, data[2]]);
  }

  render() {
    const { data, unitOptions: unitOptionsProp } = this.props;
    const unitOptions = getUnitOptions(unitOptionsProp);
    const [max, number, unit] = data;

    return (
      <div
        className="productReportSpecManagerContainer"
        id="productReportSpecManagerSpecsQuantitative"
      >
        <SpecManagerSelect
          width="152px"
          options={["Max", "Min"]}
          optionSelected={max || "Max"}
          onSelect={this.onRangeOptionClick}
        />
        <SpecManagerInput
          placeHolder="eg: 20"
          onChange={this.onInputChange}
          value={number}
          width="72px"
        />
        <SpecManagerSelect
          width="84px"
          optionSelected={unit || "None"}
          options={unitOptions}
          onSelect={this.onUnitOptionClick}
        />
      </div>
    );
  }
}
